import api from "@/data/services/api";
import { QuizMapper } from "../mapper/quiz.mapper";

export class QuizService {
  getQuizList() {
    return api
      .get(`/quiz`)
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          console.log('response == > ', response.data.data)
          console.log('response == > ', response)
          return QuizMapper.mapToQuizList(response.data.data);
        } else {
          throw 'Error: Wrong Status';
        }
      });
  }
  getQuizQuestions(slug) {
    return api
      .get(`/quiz/questions/${slug}`)
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          console.log('response == > ', response.data.data)
          console.log('response == > ', response)
          return QuizMapper.mapToQuizQuestions(response.data.data);
        } else {
          throw 'Error: Wrong Status';
        }
      });
  }
  getQuiz(slug) {
    console.log('quiz api', slug);
    return api
      .get(`/quiz/${slug}`)
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          console.log('response == > ', response.data.data)
          console.log('response == > ', response)
          return QuizMapper.mapToQuizDetail(response.data.data);
        } else {
          throw 'Error: Wrong Status';
        }
      });
  }
  createQuiz(data) {
    return api.post('/quiz', data)
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          console.log('response == > ', response.data.data)
          console.log('response == > ', response)
          return response.data.data;
        } else {
          throw 'Error: Wrong Status';
        }
      });
  }
  updateQuiz(id, data) {
    return api.patch(`/quiz/${id}`, data)
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          console.log('response == > ', response.data.data)
          console.log('response == > ', response)
          return response.data.data;
        } else {
          throw 'Error: Wrong Status';
        }
      });
  }
  addChoiceQuestion(data) {
    const request = QuizMapper.mapToChoiceQuestionJson(data);
    return api.post('/quiz/choiceQuestion', request)
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          console.log('response == > ', response.data.data)
          console.log('response == > ', response)
          return response.data.data;
        } else {
          throw 'Error: Wrong Status';
        }
      });
  }
  addQuestionToQuiz(quizId, data) {
    return api.post(`/quiz/addQuestion/${quizId}`, data)
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          console.log('response == > ', response.data.data)
          console.log('response == > ', response)
          return response.data.data
        } else {
          throw 'Error: Wrong Status';
        }
      });
  }
  updateChoiceQuestion(id, data) {
    const request = QuizMapper.mapToChoiceQuestionJson(data);
    return api
      .patch(`/quiz/choiceQuestion/${id}`, request)
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          console.log('response == > ', response.data.data)
          console.log('response == > ', response)
          return true;
        } else {
          throw 'Error: Wrong Status';
        }
      });
  }
  deleteChoiceQuestion(id) {
    return api
      .delete(`/quiz/choiceQuestion/${id}`)
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          console.log('response == > ', response.data.data)
          console.log('response == > ', response)
          return true;
        } else {
          throw 'Error: Wrong Status';
        }
      });
  }
  submitQuiz(quiz) {
    console.log('quiz aidpi', quiz.id);
    const request = {
      score: quiz.myScore
    }
    return api
      .post(`/quiz/${quiz.id}/score`, request)
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          console.log('response == > ', response.data.data)
          console.log('response == > ', response)
          return response.data.data;
        } else {
          throw 'Error: Wrong Status';
        }
      });
  }

}
